import { render, staticRenderFns } from "./DrawerMain.vue?vue&type=template&id=7fa4e458&scoped=true&"
import script from "./DrawerMain.vue?vue&type=script&lang=js&"
export * from "./DrawerMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4e458",
  null
  
)

export default component.exports